import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const ForOfficialUse = (props) => {
    const { beneDetail, editMode, partnerType, approver, approverAttribute, getApprover } = props;
    return (
        <div className="x_content" style={{ display: 'block' }} >
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Months of assistance remaining</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail ? beneDetail.No_of_Receipt_Max__c : ''}
                        disabled
                    />
                </div>
                <div className="form-group">
                    <label>No. of months to approve</label>
                    <input
                        type="number"
                        min="1"
                        className="form-control"
                        value={beneDetail ? beneDetail.No_of_Receipts_Approved__c : ''}
                        onChange={e => props.onFormChanged('No_of_Receipts_Approved__c', e.target.value)}
                        disabled={partnerType === 'School' ? true : !editMode}
                    />
                </div>
                <div className="form-group">
                    <label>Approver</label>
                    <input
                        type="text"
                        className="form-control"
                        value={(beneDetail && beneDetail.Approver_Name__r) ? beneDetail.Approver_Name__r.Name : 'Not Selected'}
                        disabled
                    />
                    <button
                        type="button"
                        className="btn btn-info form-control"
                        onClick={() => {
                            approverAttribute.modalToggle(true);
                            getApprover()
                        }}
                    >
                        <i className="fa fa-user" />
                        Select Approver
                    </button>
                    {/* <select
                        className="form-control"
                        disabled={false}
                    >
                        {props.getPicklist('Person__c', 'ID_Type__c')}
                    </select> */}
                </div>
                
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Payout Start Date</label>
                    <DatePicker
                        className="form-control"
                        selected={beneDetail ? (beneDetail.Payout_Start__c ? moment(beneDetail.Payout_Start__c) : null) : null}
                        onChange={val => props.onFormChanged('Payout_Start__c', val)}
                        dateFormat="DD/MM/YYYY"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        // isClearable={partnerType === 'School' ? false : editMode}
                        disabled={partnerType === 'School' ? true : !editMode}
                    />
                </div>
                
                <div className="form-group">
                    <label>Extension (In no. of months)</label>
                    <input
                        type="number"
                        className="form-control"
                        value={beneDetail ? beneDetail.Extension_In_no_of_months__c : ''}
                        onChange={e => props.onFormChanged('Extension_In_no_of_months__c', e.target.value)}
                        disabled={(partnerType === 'School' ? true : !editMode) || !beneDetail.Approve_Exception__c}
                    />
                </div>

                <div className="form-group">
                    <label>Approve Exception</label>
                    <input
                        type="checkbox"
                        style={{ width: 20, height: 20 }}
                        checked={beneDetail ? beneDetail.Approve_Exception__c : null}
                        onChange={e => props.onFormChanged('Approve_Exception__c', e.target.checked)}
                        disabled={!editMode}
                    />
                </div>
               
                {/* <div className="form-group">
                    <label>Payout End</label>
                    <DatePicker
                        className="form-control"
                        selected={beneDetail ? (beneDetail.Payout_End__c ? moment(beneDetail.Payout_End__c) : null) : null}
                        disabled={!editMode}
                        onChange={val => props.onFormChanged('Payout_End__c', val)}
                        isClearable
                    />
                </div> */}
            </div>
            <div className="clearfix" />
            <div className="modal modal-backdrop" data-backdrop="static" tabIndex="-1" role="dialog" style={{ display: approverAttribute.modalVisible ? 'unset' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered" role="document" style={{
                    transform: 'translate(0, -50%)',
                    top: '50%',
                    margin: '0 auto',
                    zIndex: 1,
                }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => {approverAttribute.modalToggle(false)}}><span aria-hidden="true">&times;</span></button>
                            <h4 className="modal-title">Select Approver</h4>
                        </div>
                        <div className="modal-body">
                            {
                                approver.map(x => 
                                    <button
                                        type="button"
                                        className="btn btn-success form-control"
                                        onClick={() => approverAttribute.submitApprover(x)}
                                    >
                                        {x.Name}
                                    </button>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ForOfficialUse.propTypes = {
    beneDetail: PropTypes.object,
    editMode: PropTypes.bool,
    partnerType: PropTypes.string,
    onFormChanged: PropTypes.func.isRequired,
};

ForOfficialUse.defaultProps = {
    beneDetail: null,
    editMode: false,
    partnerType: '',
};

export default ForOfficialUse;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/components/BeneficiaryForOfficialUse.js
// module id = 890
// module chunks = 0